/*

DEPRECATED use useS3DirectUploadInstead

*/
import {envAwarePost} from '../util/util'
import {useState} from 'react'
import isImage from 'is-image'
import { readAndCompressImage } from 'browser-image-resizer'
import imageCompression from 'browser-image-compression'

/*-----------------------------------

Hook that facilitates the Upload flow documented here:
- https://fitsw.atlassian.net/wiki/spaces/FITSW/pages/445284356/Upload+API

Returns destructurable object for easy integration into Components

-----------------------------------*/

const alertError = () => {
	window.alert('There was an error saving the attached document. Please, try again.')
}

const optimizeImage = async file => {
	//restrict to 100KB
	const compressedFile = await imageCompression( file, {maxSizeMB:0.1} )
	//restrict two max width of 500px
	const resizedFile = await readAndCompressImage( compressedFile, {width:500} )
	return resizedFile
}

const uploadToS3 = async (file, signed_url, success, fail) => {
	if(isImage(file.name)&&file.type!=="image/gif") file = await optimizeImage(file)
	return fetch(signed_url,{
		method:'PUT',
		body:file
	})
}

const cleanFailedUpload = (upload_id) => {
	envAwarePost('api/uploads/api/',{
		action:'cleanFailedUpload',
		upload_id
	})
}

/*
	Pass in object of form 
	{
		success:<function>,
		fail:<function>
	}
	success is a callback to fire when the upload process succeeds
	fail is a callback to fire if the upload fails somewhere

	Observe: input is destructured
*/


const useDirectUpload = ({success,fail})=>{
	// console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
	// console.log('DEPRECATED use useS3DirectUploadInstead')
	// console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
	//idle if not uploading to S3
	//pending if currently uploading to S3
	const [uploadStatus,setUploadStatus] = useState('idle')
	//if we user is in the process of uploading a file
	const [isUploading,setIsUploading] = useState(false)
	//file to be upload
	const [file,setFile] = useState(null)
	//handler for uploading
	const handleUpload = ()=>{
		//set pending status
		setUploadStatus('pending')
		//retrive signed url from our server
		envAwarePost('api/uploads/api/',{
			action:'getSignedUrl',
			file_extension:file?.name.split('.').pop()
		}).then(res=>{
			//handle failed messing from our server
			if(res.success === '0') throw res.message
			//pull data from response
			const {signed_url,upload_id,url} = res.data
			//upload file to s4
			uploadToS3(file,signed_url,success,fail).then(res=>{
				//full upload cycle is complete return to idle stataus
				setUploadStatus('idle')
				if(res.status === 200){
					success(url,upload_id)
				}else{
					console.log('did this')
					cleanFailedUpload(upload_id)
					alertError()
					fail()
				}
			})
		}).catch(err=>{
			//upload failed somewhere return to idle status
			setUploadStatus('idle')
			alertError()
			fail(err)
		})
	}
	//wrap some local state calls in a helper
	const clearUpload = ()=>{
		setFile(null)
		setIsUploading(false)
	}
	//wrap some local state calls in a helper
	//if(file) is here since input onchange events 
	//will be fired if no file is selected resulting
	//in undesired state changes. ie we only want to 
	//modify the local state if there is actually a file
	const setUpload = (file)=>{
		if(file){
			setFile(file)
			setIsUploading(true)
		}
	}
	//expose needed variables and functions 
	return {file,handleUpload,setUpload,clearUpload,isUploading,uploadStatus}
}

export default useDirectUpload